import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.api
 * @constructor
 */
export class ApiTotalsModel extends BaseModel {
  /**
   * @param {number} totalItems
   * @param {number} totalPages
   * @param {number} page
   * @param {number} perPage
   * @param {number} [paginationLimit]
   * @param {boolean} [paginationUnsupported]
   */
  constructor({
    totalItems,
    totalPages,
    page,
    perPage,
    paginationLimit,
    paginationUnsupported,
  }) {
    super()

    /** @type {number} */
    this.totalItems = totalItems

    /** @type {number} */
    this.totalPages = totalPages

    /** @type {number} */
    this.page = page

    /** @type {number} */
    this.perPage = perPage

    /** @type {null|number} */
    this.paginationLimit = paginationLimit ?? null

    /** @type {boolean} */
    this.paginationUnsupported = paginationUnsupported ?? false
  }
}
